<template>
    <div class="awr-unscramble">
        <mc-operate-bar>
            <template slot="right">
                <el-tooltip effect="dark" content="刷新" placement="bottom" transition="none">
                    <el-button type="default" size="" @click="this.$_getList" icon="el-icon-refresh" style="margin-right: 10px;"
                        circle></el-button>
                </el-tooltip>
                <el-button type="primary" size="" @click="dialog.upLoad.methods.open">AWR报告上传</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{ $_handleTime(scope.row.upload_time) }}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span style="color:#1890ff;text-decoration:underline;cursor:pointer" @click="$_gotoHtml(scope.row.history_id)">{{
                            scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 100">
                            <el-button size="mini" type="primary" @click="$_doAnalyze(scope.row.history_id)">开始</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 110">
                            解读中..
                        </span>
                        <span v-else-if="scope.row.status == 120">
                            <el-button size="mini" @click="$_gotoMarkdown(scope.row.history_id)">查看</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 130" style="color: #909399">
                            <el-button size="mini" type="warning" @click="$_doAnalyze(scope.row.history_id)">重试</el-button>
                        </span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="comprehensive-inspection-pager" @getList="$_getList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.upLoad">
            <template slot="content">
                <mc-layout-row label-text="选择文件" :label-width="120" align-column="top" content-align-row="left">
                    <el-button type="primary" @click="$_fileButton">选择文件</el-button>
                    <input type="file" v-show="false" class='selectfile' @change='$_handleFileChange' ref='selectfile' />
                    <mc-label style="margin-left:10px;" icon="el-icon-warning" warn>仅支持.html格式文件</mc-label>
                </mc-layout-row>
                <mc-label icon="el-icon-document" success v-show="dialog.upLoad.data.fileName">
                    {{dialog.upLoad.data.fileName}}
                </mc-label>
                <mc-layout-row :label-show="false">
                    <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="dialog.upLoad.data.text"></el-input>
                </mc-layout-row>
            </template>
            <template slot="footer">
                <el-button icon="el-icon-upload2" type="primary" @click="$_postAwrReport" :loading="dialog.upLoad.state.isLoading">上传</el-button>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "awr-unscramble",
        data() {
            return {
                fileList: [],
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    head: [{
                            prop: "upload_time",
                            label: "AWR报告上传时间",
                        },
                        {
                            prop: "name",
                            label: "AWR报告名称",
                        },
                        {
                            prop: "description",
                            label: "备注",
                        },
                        {
                            prop: "status",
                            label: "操作",
                            width: "100"
                        },
                    ],
                },
                dialog: {
                    upLoad: {
                        visible: false,
                        state: {
                            isLoading: false,
                        },
                        title: "上传AWR报告",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                            width: '500px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.upLoad.data.text = "";
                                this.dialog.upLoad.data.file = "";
                                this.dialog.upLoad.data.fileName = "";
                                this.dialog.upLoad.visible = true;
                            },
                        },
                        data: {
                            text: "",
                            file: "",
                            fileName: ""
                        },
                    }
                },
            }
        },
        methods: {
            $_getList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                };
                let data = await this.$api.userAwrUnscramble.getList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_postAwrReport: async function () {
                this.dialog.upLoad.state.isLoading = true;
                let formData = new FormData();
                formData.append("file", this.dialog.upLoad.data.file);
                formData.append("description", this.dialog.upLoad.data.text);
                let data = await this.$api.userAwrUnscramble.postAwrReport.call(this, formData);
                if (data !== false) {
                    this.dialog.upLoad.visible = false;
                    this.$_getList();
                    this.$message.success('上传成功!')
                }
                this.dialog.upLoad.state.isLoading = false;
            },
            $_doAnalyze: async function (id) {
                let params = {
                    history_id: id
                };
                let data = await this.$api.userAwrUnscramble.doAnalyze.call(this, params);
                if (data !== false) {
                    this.$_getList();
                }
            },
            $_handleFileChange() {
                let inputDom = this.$refs.selectfile;
                this.dialog.upLoad.data.file = inputDom.files[0];
                this.dialog.upLoad.data.fileName = inputDom.files[0].name;
            },
            $_handleTime(item) {
                let date = new Date(item)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
            },
            $_fileButton() {
                this.$refs.selectfile.click();
            },
            $_gotoHtml(id) {
                this.$router.push({
                    name: 'user-html-report',
                    params: {
                        history_id: id
                    }
                });
            },
            $_gotoMarkdown(id) {
                this.$router.push({
                    name: 'user-markdown-report',
                    params: {
                        history_id: id
                    }
                });
            }
        },
        mounted() {
            this.$_getList();
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .awr-unscramble {
        width: 100%;

        .btn-box {
            display: flex;
            flex-direction: row-reverse;
            margin-right: 10px;
            padding: 10px 10px 15px 0;
        }

        .el-dialog {
            .site-item {
                display: inline-flex;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 65px;
                    text-align: left;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }
    }
</style>